ExperienceIntro =  {

	controller : false
	wHeight : false

	init : ->		
		# Init scrollMagic
		#@controller = new ScrollMagic.Controller() ; 
		#@wHeight = $(window).height()

		if not Config.isMobile()
		 #	@scrollManager()
			@videoManager()
		#	@autoLoadManager()



	scrollManager : ->

		# Anim video
		videoContainer = $('.block-experience-intro .video-container')
		scene = new ScrollMagic.Scene({triggerElement: videoContainer[0], duration: $('.experience-intro--desc').height() - 130, triggerHook: 0.1, force3D:true})
			.setPin(videoContainer[0])
			.addTo(@controller)

		tween = new TimelineLite
		tween.addLabel('start')
		tween.to videoContainer.find('.video--embed'), 1, {width: '100%', ease:Expo.easeInOut}, 'start'
			.to videoContainer.find('.video--poster'), 1, {css:{left: 0, x: '0%'}, ease:Expo.easeInOut}, 'start'
		scene = new ScrollMagic.Scene({triggerElement: '.experience-intro--desc', offset: $('.experience-intro--desc').height(), triggerHook: 0.1})
			.setTween(tween)
			.addTo(@controller)		

		# Anim shape
		tween = TweenLite.to $('.experience-intro--desc').find(".start"), 1, {morphSVG: $('.experience-intro--desc').find(".end"), ease:Linear.easeNone}
		scene = new ScrollMagic.Scene({triggerElement: '.experience-intro--desc', offset: @wHeight/1.5, duration : @wHeight/2})
			.setTween(tween)
			.addTo(@controller)

		# Hide video if scroll past it
		scene = new ScrollMagic.Scene({triggerElement: '#valeurs', triggerHook: 0})
			.on "enter", (ev) ->
				if videoContainer.find('iframe').length
					TweenLite.set videoContainer.find('iframe'), {autoAlpha: 0}
					TweenLite.set $('.cta-play-container'), {autoAlpha:1, scale:1}
			.addTo @controller
			

	videoManager : ->
		
		elt = $('.block-experience-intro .video--embed')[0]
		youtubeId = $(elt).attr('data-embed')
		$(elt).children('.cta-play-container').on "click", (ev) ->
			if $(elt).find('iframe').length
				$(elt).find('iframe').remove()
			ev.preventDefault()
			#TweenLite.to $(@), 0.4, {scale:1.2, ease:Expo.easeOut}
			#TweenLite.to $(@), 0.4, {scale:0.7, autoAlpha:0, ease:Expo.easeIn, delay: 0.4}
			
			$('.experience-intro--video').addClass("open")
			$(".block-experience-intro .fs-overlay").addClass("visible");
			tlVideoAnim = new TimelineLite
			tlVideoAnim.to(window, 1, { scrollTo: {y: $('.experience-intro--video').offset().top - 50 }, ease:Quint.easeInOut })
			tlVideoAnim.add ->
				iframe = document.createElement("iframe")
				iframe.setAttribute("frameborder", "0")
				iframe.setAttribute("allowfullscreen", "")
				iframe.setAttribute("src", "https://www.youtube.com/embed/" + youtubeId + "?rel=0&showinfo=0&autoplay=1")
				# elt.innerHTML = ""
				elt.appendChild(iframe)
			, '+=0.2'
			setTimeout ( ->
				
				$(document).on "click", (ev) ->
					console.log 'Click document'

					if $('.experience-intro--video').hasClass("open")
						$(".experience-intro--video").removeClass("open")
						$(".block-experience-intro .fs-overlay").removeClass("visible");
						$(document).off "click"
						$('.block-experience-intro iframe').remove()
		
			), 1000
		


	autoLoadManager : ->

		console.log "autoLoad init"
		url = window.location.href.indexOf '#video'
		elt = $('.block-experience-intro .video--embed')[0]
		youtubeId = $(elt).attr('data-embed')
		if url > -1
			if $(elt).find('iframe').length
				$(elt).find('iframe').remove()
			TweenLite.to $(@), 0.4, {scale:1.2, ease:Expo.easeOut}
			TweenLite.to $(@), 0.4, {scale:0.7, autoAlpha:0, ease:Expo.easeIn, delay: 0.4}
			tlVideoAnim = new TimelineLite
			tlVideoAnim.to(window, 1, { scrollTo: {y: $('.experience-intro--desc'), offsetY: -parseInt($('.experience-intro--desc').height())}, ease:Quint.easeInOut })
			tlVideoAnim.add ->
				iframe = document.createElement("iframe")
				iframe.setAttribute("frameborder", "0")
				iframe.setAttribute("allowfullscreen", "")
				iframe.setAttribute("src", "https://www.youtube.com/embed/" + youtubeId + "?rel=0&showinfo=0&autoplay=1")
				# elt.innerHTML = ""
				elt.appendChild(iframe)
			, '+=0.2'

	destroy : ->
		console.log "ExperienceIntro destroy"		
}